import RepoApiRequest from '../../utils/bcc-repo-api-request';
import endpoints from '../repo-api-endpoints';

const availablePageIndexes = [ 'home', 'about', 'contact', 'contribute' ];

const read = async (id) => {
  try {
    if (!availablePageIndexes.includes(id)) throw new Error("page id not in available page index");
    const result = await RepoApiRequest({ url: endpoints.page.get(id) });
    // console.log(result);
    return result;
  } catch(err) {
    console.error("Error getting page data", err);
    return null;
  }
  // return result;
}

const pageRepository = { read };

export { read }
export default pageRepository